export function getImages(images) {
  return images?.filter(image => !image.mime_type?.startsWith('video/'))
}
